import React from 'react';

const PopupActionView: React.FC<{
  onClick?: () => void;
  className: string;
  dataCy?: string;
  children: React.ReactNode;
}> = ({ onClick, className, children, dataCy }) => {
  return (
    <button
      className={className}
      onClick={onClick}
      data-cy={dataCy}
    >
      {children}
    </button>
  );
};

export default PopupActionView;
